<template>
  <section id="psychologist" class="bg-grey-light3 lg:mb-16 mb-10">
    <div class="md:container px-4 py-14">
      <div class="flex flex-wrap lg:flex-nowrap">
        <div class="w-full lg:w-1/2 lg:mr-4 lg:mb-0 mb-6">
          <p class="tracking-widest uppercase text-primary font-rubik-medium">
            {{ $t("psychologist.title") }}
          </p>
          <h3 class="font-bree-serif md:text-3xl mt-4 mb-6">
            {{ $t("psychologist.subtitle") }}
          </h3>
          <p class="md:text-lg mb-8">
            {{ $t("psychologist.desc") }}
          </p>
          <template v-for="(check, index) in checkLists">
            <div :key="index" class="flex items-center mb-3">
              <img
                v-lazy-load data-src="@/assets/icon/icon-checkbox.svg"
                alt=""
                class="inline-block mr-3"
              />
              <span class="text-lg font-rubik-medium">{{ $t(check.name) }}</span>
            </div>
          </template>
          <div class="flex flex-wrap sm:flex-nowrap mt-6">
            <button
              class="btn btn-success sm:w-2/5 sm:mr-6 sm:mb-0 mb-4 w-full text-xl uppercase"
              @click="
                redirectRegister
              "
            >
              {{ $t("signup") }}
            </button>
            <button
              class="btn btn-primary sm:w-2/5 w-full text-xl uppercase"
              @click="handleLogin"
            >
              {{ $t("signin") }}
            </button>
          </div>
        </div>
        <div class="w-full lg:w-1/2">
          <img
            v-lazy-load data-src="@/assets/img/img-for-psychologist.png"
            alt=""
            class="mx-auto"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Psychologist',
  data: () => ({
    checkLists: [
      {
        name: 'checkListPsycholog.first'
      },
      {
        name: 'checkListPsycholog.second'
      },
      {
        name: 'checkListPsycholog.third'
      }
    ]
  }),
  methods: {
    handleLogin () {
      window.location.href = `${process.env.BASE_SPECIALIST_URL}/auth/login?target=psychologist`
    },
    async redirectRegister () {
      await this.$store.commit('SET_REGISTER_TYPE', 'PSYCHOLOGIST')
      await this.$router.push(this.localeLocation({ path: '/register/psycholog' }))
    }
  }
}
</script>
  <style scoped>
</style>
